import type { CSSProperties } from 'react';

/**
 * Converts a JavaScript style object with camelCase properties
 * to a CSS string with kebab-case properties.
 *
 * @param styles - An object with camelCase CSS property names and their values
 * @returns A string of CSS property declarations separated by newlines
 *
 * @example
 * ```ts
 * toCSSProperties({ backgroundColor: 'red', fontSize: 16 });
 * // Returns: "background-color: red;\nfont-size: 16;"
 * ```
 */
export function toCSSProperties(styles: CSSProperties): string {
  return Object.entries(styles)
    .map(([key, value]) => {
      const kebabCase = key.replace(/([A-Z])/g, '-$1').toLowerCase();
      return `${kebabCase}: ${value};`;
    })
    .join('\n');
}
